import { ContactsTierSelectWidgetContent } from './ContactsTierSelectWidgetContent';
import type { ContactsTierSelectWidgetProps } from './useContactsTierSelectWidget';
import { WithStatusHandling } from '../WithStatusHandling';

export const ContactsTierSelectWidget = ({
  status,
  handlers,
  data,
  hooks,
  isSingleBillChildAccount,
}: ContactsTierSelectWidgetProps) => {
  return (
    <WithStatusHandling
      skeletonHeight={46}
      status={status}
      errorMessage={status === 'error' ? data.message : undefined}
      retry={status === 'error' ? handlers.retry : undefined}
    >
      {status === 'loaded' && (
        <ContactsTierSelectWidgetContent
          data={data}
          handlers={handlers}
          hooks={hooks}
          isSingleBillChildAccount={isSingleBillChildAccount}
        />
      )}
    </WithStatusHandling>
  );
};
